// @flow
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions";
import { Row, Col } from "antd";
import { Form, Icon, Input, Button } from "antd";
import { Link } from "react-router-dom";
import type { State } from "../../types/store";
import type { User } from "../../reducers/auth";
import "./style.css";
const FormItem = Form.Item;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}
type Props = {
  user?: User,
  isFetching: boolean,
  onRecoverPassword: Function,
  form: Object,
  location: Object
};
class ForgotPasswordPage extends React.Component<Props> {
  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { location, onRecoverPassword } = this.props;
        const from = location.state ? location.state.from.pathname : null;
        console.log("prfromops: ", from);
        onRecoverPassword(values, from);
      }
    });
  };
  onValuesChange = (props, values) => {
    //console.log("props: ", props);
    //console.log("values: ", values);
  };
  render() {
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched
    } = this.props.form;
    // Only show error after a field is touched.
    const emailError = isFieldTouched("email") && getFieldError("email");

    const { isFetching } = this.props;
    return (
      <Row className="login padding-for-nav" type="flex" align="middle">
        <Col xs={{ span: 22, offset: 1 }} sm={{ span: 8, offset: 8 }}>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem
              validateStatus={emailError ? "error" : ""}
              help={emailError || ""}
            >
              {getFieldDecorator("email", {
                rules: [
                  {
                    type: "email",
                    message: "The input is not valid E-mail!"
                  },
                  {
                    required: true,
                    message: "Please input your E-mail!"
                  }
                ]
              })(
                <Input
                  prefix={<Icon type="mail" style={{ fontSize: 13 }} />}
                  placeholder="Please input your E-mail"
                />
              )}
            </FormItem>
            <FormItem>
              <Link className="login-form-forgot" to="/">
                Back to Login
              </Link>
            </FormItem>
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={isFetching}
                disabled={hasErrors(getFieldsError())}
              >
                Recover Password
              </Button>
            </FormItem>
          </Form>
        </Col>
      </Row>
    );
  }
}
ForgotPasswordPage = Form.create()(ForgotPasswordPage);

function mapStateToProps(state: State) {
  const { user, isFetching } = state.auth;
  return {
    user,
    isFetching
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onRecoverPassword: bindActionCreators(actions.recoverPassword, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);

ForgotPasswordPage.propTypes = {
  user: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  onRecoverPassword: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/forgotpassword/index.js